
import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiMenu, FiX } from 'react-icons/fi';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Projects', href: '#portfolio' },
    { name: 'Expertise', href: '#services' },
    { name: 'Investment', href: '#pricing' },
    { name: 'Contact', href: '#contact' }
  ];

  return (
    <nav className={`fixed w-full z-50 transition-all duration-500 ${isScrolled ? 'bg-neutral-950/90 backdrop-blur-md py-4' : 'bg-transparent py-6'}`}>
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex justify-between items-center">
        <a href="#" className="z-50 relative flex items-center">
          <img src="https://media-manager-c.questera.ai/greta-media/ed00222917f6c77a55ea8d2212b2179b0f515c1262a399d5885ad9a7986bc697479c974a1fb3a0fd5daf63013277d6b3/images/aW1hZ2UvcG5n/1a35cb15935008635dadd9d4f6191635.png" alt="VZION by DASZeph" className="h-10 md:h-20 w-auto object-contain transition-all duration-300" />
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex space-x-8">
          {navLinks.map((link) => (
            <a key={link.name} href={link.href} className="text-neutral-300 hover:text-white transition-colors text-sm uppercase tracking-wider" >
              {link.name}
            </a>
          ))}
        </div>

        {/* Mobile Toggle */}
        <button className="md:hidden text-white z-50 relative" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} >
          <SafeIcon icon={mobileMenuOpen ? FiX : FiMenu} className="w-6 h-6" />
        </button>

        {/* Mobile Nav */}
        <AnimatePresence>
          {mobileMenuOpen && (
            <motion.div initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -20 }} className="absolute top-0 left-0 w-full h-screen bg-neutral-950 flex flex-col items-center justify-center space-y-8" >
              {navLinks.map((link) => (
                <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="text-neutral-300 hover:text-white transition-colors text-2xl uppercase tracking-widest" >
                  {link.name}
                </a>
              ))}
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </nav>
  );
};

export default Navbar;
